// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__19x5P","actionsCol":"EnrolledClinics_actionsCol__1DRDa"};